import { useNodes, useStore } from '@xyflow/react';
import { memo, useEffect } from 'react';

import { NodeType } from '@/components/flow';
import { DEFAULT_SELECTED_NODE } from '@/constants';

import { ExportPanelSlideOut } from './ExportPanelSlideOut';

export type ExportPanelSlideOutWrapperProps = {
  agentId: string;
};

const IExportPanelSlideOutWrapper = ({ agentId }: ExportPanelSlideOutWrapperProps) => {
  const nodes = useNodes() as NodeType[];
  const selectedNode = nodes.find((node) => node.selected);
  const addSelectedNodes = useStore((state) => state.addSelectedNodes);

  useEffect(() => {
    const defaultSelectedNode = sessionStorage.getItem(DEFAULT_SELECTED_NODE);
    if (defaultSelectedNode != null) {
      const selected = nodes.find((node) => node.data.resourceIds.includes(defaultSelectedNode));
      if (selected) {
        addSelectedNodes([selected.id]);
        sessionStorage.removeItem(DEFAULT_SELECTED_NODE);
      }
    }
  }, [addSelectedNodes, nodes, selectedNode]);

  const actionId = selectedNode?.data.resourceIds.find((r) => r.startsWith('cradl:action'));
  const hookId = selectedNode?.data.resourceIds.find((r) => r.startsWith('cradl:hook'));

  if (!actionId || !hookId || !selectedNode || selectedNode.data.resourceGroupType !== 'export') {
    return null;
  }

  return <ExportPanelSlideOut agentId={agentId} actionId={actionId} hookId={hookId} />;
};

export const ExportPanelSlideOutWrapper = memo(IExportPanelSlideOutWrapper) as typeof IExportPanelSlideOutWrapper;
